<template>
	<ja-radial-progress-bar
		:size="62"
		:value="budgetPercentage"
		:title="isInBudgetingPhase ? $t('leftToBudget') : $t('budgetLeft')"
		:status="moneyLeft | currency"
		:aria-label="ariaLabel"
		role="img"
	>
		<template v-slot:icon>
			<svgicon
				:class="`icon${JA_LOCALIZATION_IRL ? '-ir' : ''}`"
				:name="`hud/budget-left${JA_LOCALIZATION_IRL ? '-ir' : ''}`"
				:original="true"
				:aria-hidden="true"
			></svgicon>
		</template>
	</ja-radial-progress-bar>
</template>
<script>
import '../icons/hud/budget-left';
import ProfileData from '@/mixins/ProfileData';
import LifeStageData from '@/mixins/LifeStageData';
import RadialProgressBar from '../ui/RadialProgressBar';

export default {
	components: {
		jaRadialProgressBar: RadialProgressBar
	},
	mixins: [ProfileData, LifeStageData],
	props: {
		isLink: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			JA_LOCALIZATION_IRL: this.$store.getters.isIrl
		};
	},
	computed: {
		ariaLabel() {
			const labelArr = [
				this.$t('currentBudget', {
					budget: this.netMonthlyIncome - this.lifeStageData.totalExpenses
				})
			];
			if (this.isLink) {
				labelArr.push(this.$t('navigateToProfile'));
			}

			return labelArr.join(';');
		},
		moneyLeft() {
			if (this.isInBudgetingPhase) {
				return this.getLeftToBudget();
			}
			return this.netMonthlyIncome - this.lifeStageData.totalExpenses;
		},
		budgetPercentage() {
			const maxPercentage = 100;
			if (this.lifeStageData) {
				let result = parseInt(
					(
						((this.netMonthlyIncome - this.lifeStageData.totalExpenses) /
							this.netMonthlyIncome) *
						100
					).toFixed(0)
				);
				return result > maxPercentage ? maxPercentage : result;
			}

			return null;
		}
	}
};
</script>
<style lang="scss" scoped>
.icon {
	height: 30px;
	width: 30px;
	fill: #0d6217;
}

.icon-ir {
	height: 40px;
	width: 40px;
	fill: #0d6217;
}
</style>
